(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-minimal"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.openDetails = [];
      this.overlay = document.querySelector('.header__backdrop');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => {
        if (disclosure && disclosure.close) {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal.close) {
        this.searchModal.close(false);
      }
    }

    closeMenu(el) {
      let index = this.openDetails.indexOf(el, 0);
      if (index > -1) {
        this.openDetails.splice(index, 1);
      }
      setTimeout(() => {
        this.setOverlayVisibility();
      }, 100);
    }

    openMenu(el) {
      this.openDetails.push(el);
      this.setOverlayVisibility();
    }

    setOverlayVisibility() {
      let isVisible = this.overlay.classList.contains('header__backdrop--open');
      if (this.openDetails.length > 0) {
        if (isVisible === false) {
          this.overlay.classList.add('header__backdrop--open');
        }
      } else {
        this.overlay.classList.remove('header__backdrop--open');
      }
    }
  }

  const headerNav = document.querySelector('.header-wrapper');
  const headerNavDistance = headerNav.getBoundingClientRect().top;
  const headerNavHeight = headerNav.getBoundingClientRect().height;

  document.documentElement.style.setProperty(
    '--full-header-height',
    `${headerNavHeight + headerNavDistance}px`
  );

  window.addEventListener('scroll', () => {
    if (headerNav.getBoundingClientRect().top !== 0) {
      document.documentElement.style.setProperty(
        '--full-header-height',
        `${headerNavHeight + headerNavDistance}px`
      );
    } else {
      document.documentElement.style.setProperty('--full-header-height', `${headerNavHeight}px`);
    }
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.openDetails = [];
      this.overlay = document.querySelector('.header__backdrop');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => {
        if (disclosure && disclosure.close) {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal.close) {
        this.searchModal.close(false);
      }
    }

    closeMenu(el) {
      let index = this.openDetails.indexOf(el, 0);
      if (index > -1) {
        this.openDetails.splice(index, 1);
      }
      setTimeout(() => {
        this.setOverlayVisibility();
      }, 100);
    }

    openMenu(el) {
      this.openDetails.push(el);
      this.setOverlayVisibility();
    }

    setOverlayVisibility() {
      let isVisible = this.overlay.classList.contains('header__backdrop--open');
      if (this.openDetails.length > 0) {
        if (isVisible === false) {
          this.overlay.classList.add('header__backdrop--open');
        }
      } else {
        this.overlay.classList.remove('header__backdrop--open');
      }
    }
  }

  const headerNav = document.querySelector('.header-wrapper');
  const headerNavDistance = headerNav.getBoundingClientRect().top;
  const headerNavHeight = headerNav.getBoundingClientRect().height;

  document.documentElement.style.setProperty(
    '--full-header-height',
    `${headerNavHeight + headerNavDistance}px`
  );

  window.addEventListener('scroll', () => {
    if (headerNav.getBoundingClientRect().top !== 0) {
      document.documentElement.style.setProperty(
        '--full-header-height',
        `${headerNavHeight + headerNavDistance}px`
      );
    } else {
      document.documentElement.style.setProperty('--full-header-height', `${headerNavHeight}px`);
    }
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-hero"] && !Shopify.designMode) return;
  try {
    
  // Marquee text
  class MarqueeText extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.currentIndex = 0;
      this.marqueeElements = this.children;
      let animationDelay = 1.2;
      if (this.dataset.animationDelay) {
        animationDelay = this.dataset.animationDelay;
      }
      animationDelay = +animationDelay;
      animationDelay = animationDelay * 1000;

      setInterval(() => this.scrollText(), animationDelay);
    }

    scrollText() {
      const element = this.marqueeElements[this.currentIndex];

      const nextElement =
        this.currentIndex === this.marqueeElements.length - 1
          ? this.marqueeElements[0]
          : this.marqueeElements[this.currentIndex + 1];

      element.classList.add('animate-out');
      element.classList.remove('animate-in');

      setTimeout(() => {
        element.style.display = 'none';
        element.classList.remove('animate-out');
      }, 450);

      nextElement.classList.add('animate-in');

      this.currentIndex += 1;

      if (this.currentIndex == this.marqueeElements.length) {
        this.currentIndex = 0;
      }
    }
  }

  customElements.define('marquee-text', MarqueeText);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const isSquareButtons =
        document.querySelector('#page-template')?.dataset.template === 'product.gift-card';

      if (bitcube.squareButtonTemplate) {
        const isSquare = window.bitcube.squareButtonTemplate;

        if (isSquare === window.location.href) {
          const isSquareButtons = true;
          return isSquareButtons;
        }
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (isSquareButtons) {
              this.querySelectorAll('product-recommendations .button').forEach((btn) => {
                btn.classList.add('button--square');
              });
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
